module.exports = __webpack_public_path__ + "img/background-app-shop-blue.a454d923.jpg";